import { createContext, useContext, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import useFeaturePermission from "../util/hooks/useFeaturePermission";

const PermissionsContext = createContext({ canEdit: false });

export const PermissionsProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const pathPart = location.pathname.split("/")[1];

  const pathToFeatureId: Record<string, number> = {
    staff: 1,
    admissions: 2,
    queries: 2,
    messages: 3,
    "notice-board": 4,
    "fees-and-payments": 5,
    "payroll-management": 6,
    "calendar-and-events": 7,
    "media-gallery": 8,
  };

  const featureId = pathToFeatureId[pathPart];

  const { canEdit } = useFeaturePermission(featureId);

  const shouldApplyPermission = featureId !== undefined;

  return (
    <PermissionsContext.Provider value={{ canEdit }}>
      <div
        className={`relative h-full ${
          shouldApplyPermission && !canEdit ? "is-view-only" : ""
        }`}
      >
        {shouldApplyPermission && !canEdit && (
          <div
            className="absolute inset-0 z-[9999] cursor-not-allowed"
            title="You do not have permission to edit this feature"
            onClick={(e) => e.stopPropagation()}
          />
        )}

        {children}
      </div>
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionsContext);